const BASE_API_URL = (process.env.REACT_APP_API_URL ?? '') + '/local/components/iek/where_to_buy/ajax.php';
const GENERICA_SPRITE_URL = '/local/templates/.default/build/img/sprite.svg';

type Lang = 'ru';
type Template = 'iek_redisign' | 'generica_redisign' | 'itk_redisign' | 'oni_redisign' | 'new_iek' | 'new_itk' | 'old_itk' | 'generica';

declare global {
    interface Window {
        _whereToBuySettings?: {
            template: Template;
            lang: Lang;
            site: string;
            baseRoute: string;
        };
    }
}
const TEMPLATE = window._whereToBuySettings?.template || 'iek_redisign';
const LANG = window._whereToBuySettings?.lang || 'ru';
const SITE = window._whereToBuySettings?.site || 'ru';
//const BASE_ROUTE = window._whereToBuySettings?.baseRoute || '/products/where_to_buy';
export const EXCLUDED_REGIONS = ["Крым Республика", "Луганская Народная Республика","Донецкая Народная Республика" ];

export { BASE_API_URL, GENERICA_SPRITE_URL, LANG, SITE, TEMPLATE };

